import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { BiFilter } from "react-icons/bi";
import { GrPowerReset } from "react-icons/gr";
import PaginationComponent from "../../Component/Pagination/PaginationControls";
import apiCall from "./../../API/API";
import { toast, ToastContainer } from "react-toastify";
import { useLocation } from "react-router-dom";
// import ExportExcel from "../../Component/ExportExcel/ExportExcel";
import "react-toastify/dist/ReactToastify.css";

const KycReport = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [KycData, setKycData] = useState([]);
  const [currentPage, setCurrentPage] = useState(
    location.state?.currentPage || 1
  );
  const [totalPages, setTotalPages] = useState(0);
  const [filterVisible, setFilterVisible] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [exportData, setExportData] = useState([]);
  const [search, setSearch] = useState({
    email: "",
    search: "",
    bankAccount: "",
    panCard: "",
    startDate: "",
    endDate: "",
  });

  const dataLimit = 10;

  const toggleFilter = () => {
    setFilterVisible(!filterVisible);
  };

  const handlePagination = (page) => {
    setCurrentPage(page);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSearch((prev) => ({ ...prev, [name]: value }));
  };

  const AddFilter = () => {
    setCurrentPage(1); // Reset to first page on filter
    fetchKYC(1); // Fetch filtered data from first page
  };

  const fetchKYC = async (page = currentPage) => {
    const filters = Object.fromEntries(
      Object.entries(search)?.filter(([key, value]) => value !== "")
    );
    const queryParams = {
      page,
      limit: dataLimit,
      ...filters,
    };

    const queryString = new URLSearchParams(queryParams).toString();

    try {
      const { data } = await apiCall(
        "GET",
        `/all-kyc-request?${queryString}`,
        null,
        false
      );
      setKycData(data?.data);
      setTotalPages(data?.totalPages);
      setTotalRecords(data?.totalRecords);
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleExportExcel = async () => {
    try {
      // Fetch all records without page and limit params
      const { data } = await apiCall(
        "GET",
        `/all-kyc-request?limit=${totalRecords}`, // Send totalRecords as limit to fetch all
        null,
        false
      );

      setExportData(data?.data);

      // console.log("export excel response", data?.data);
      // toast.success("Excel file has been downloaded!");
    } catch (error) {
      // toast.error("Failed to export data");
    }
  };
  useEffect(() => {
    handleExportExcel();
  }, []);

  const filteredData = exportData?.filter(
    (item) =>
      item.isApproved.bank === 2 ||
      item.isApproved.pan === 2 ||
      item.isApproved.address === 2
  );

  const ResetFun = async () => {
    const resetState = {
      email: "",
      search: "",
      bankAccount: "",
      panCard: "",
      startDate: "",
      endDate: "",
    };

    setSearch(resetState);

    const queryParams = {
      page: 1,
      limit: dataLimit,
    };
    const queryString = new URLSearchParams(queryParams).toString();

    try {
      const { data } = await apiCall(
        "GET",
        `/all-kyc-request?${queryString}`,
        null,
        false
      );
      setKycData(data?.data);
      setTotalPages(data?.totalPages);
    } catch (error) {
      toast.error(error.message);
    }
  };

  useEffect(() => {
    fetchKYC();
  }, [currentPage]);

  const handleViewDetails = (username, index) => {
    navigate("/dashboard/kyc_controls", {
      state: {
        username,
        currentPage,
        userList: KycData.map((data) => data.username),
        currentIndex: index,
      },
    });
  };

  return (
    <React.Fragment>
      <Container>
        <div className="pagePath">
          <p className="m-0">
            Home / <span>KYC</span>
          </p>
          <div>
            {/* <button
              className="btnPrimary"
              style={{ margin: "0px" }}
              onClick={handleExportExcel}
            >
              Export to Excel
            </button> */}
            {/* <ExportExcel
              data={filteredData}
              columns={[
                "name",
                "username",
                "email",
                "bankDetails.bankName",
                "bankDetails.ifscCode",
                "bankDetails.accountNumber",
                "bankDetails.accountType",
                "bankDetails.holderName",
                "panDetails.panNumber",
                "addressDetails.idType",
                "addressDetails.idNumber",
                "addressDetails.name",
                "addressDetails.address",
                "nomineeDetails.idDocumentType",
                "nomineeDetails.idDocumentNumber",
                "nomineeDetails.nomineeName",
                "nomineeDetails.relationship",
              ]}
              fileName="All Users Kyc.xlsx"
            /> */}
          </div>
        </div>
        <Row id="filterRow">
          <span id="filterLogo">
            <div className="d-flex justify-content-between">
              <div onClick={toggleFilter}>
                <i>
                  <BiFilter />
                </i>
                Filter
              </div>
            </div>
          </span>

          {filterVisible && (
            <Row className="p-0 m-0">
              <Col lg="2" md="4">
                <div>
                  <input
                    type="text"
                    name="search"
                    placeholder="Search"
                    value={search.search}
                    onChange={handleChange}
                  />
                </div>
              </Col>

              <Col lg="2" md="4">
                <div>
                  <input
                    type="text"
                    name="email"
                    placeholder="Search By Email"
                    value={search.email}
                    onChange={handleChange}
                  />
                </div>
              </Col>

              <Col lg="2" md="4">
                <div>
                  <input
                    type="number"
                    name="bankAccount"
                    placeholder="Search By Account no."
                    value={search.bankAccount}
                    onChange={handleChange}
                  />
                </div>
              </Col>

              <Col lg="2" md="4">
                <div>
                  <input
                    type="text"
                    name="panCard"
                    placeholder="Search By PAN no."
                    value={search.panCard}
                    onChange={handleChange}
                  />
                </div>
              </Col>

              <Col lg="2" md="4">
                <div>
                  <input
                    type="date"
                    name="startDate"
                    placeholder="Search By Start date"
                    value={search.startDate}
                    onChange={handleChange}
                  />
                </div>
              </Col>

              <Col lg="2" md="4">
                <div>
                  <input
                    type="date"
                    name="endDate"
                    placeholder="Search By End date"
                    value={search.endDate}
                    onChange={handleChange}
                  />
                </div>
              </Col>

              <div>
                <button className="save filter" onClick={AddFilter}>
                  Filter{" "}
                  <i>
                    <BiFilter />
                  </i>
                </button>
                <button className="cancel reset" onClick={ResetFun}>
                  Reset{" "}
                  <i>
                    <GrPowerReset />
                  </i>
                </button>
              </div>
            </Row>
          )}
        </Row>

        <div id="directIncomeDiv">
          <Row id="directTableRow" className="text-center">
            <Col md="12" className="p-0">
              <div style={{ width: "100%" }}>
                <table>
                  <tr>
                    <th>S. No.</th>
                    <th>Name</th>
                    <th>Username</th>
                    <th>Status</th>
                    <th>Email</th>
                    <th>Action</th>
                  </tr>
                  <tbody>
                    {Array.isArray(KycData) &&
                      KycData.map((row, index) => (
                        <tr key={index}>
                          <td style={{ textAlign: "center" }}>
                            {(currentPage - 1) * dataLimit + index + 1}
                          </td>
                          <td style={{ textAlign: "center" }}>{row.name}</td>
                          <td style={{ textAlign: "center" }}>
                            {row.username}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {row?.isApproved &&
                              Object.entries(row?.isApproved)?.map(
                                ([key, value]) => (
                                  <div className="keyValue d-flex align-items-center gap-2">
                                    <p style={{ textAlign: "center" }}>
                                      {key} :
                                    </p>
                                    {value == "1" ? (
                                      <p>Pending</p>
                                    ) : value == "2" ? (
                                      <p>Approved</p>
                                    ) : value == "3" ? (
                                      <p>Rejected</p>
                                    ) : (
                                      <p>Pending from user</p>
                                    )}
                                  </div>
                                )
                              )}
                          </td>
                          <td style={{ textAlign: "center" }}>{row.email}</td>
                          <td style={{ textAlign: "center" }}>
                            <button
                              className="block-btn"
                              onClick={() =>
                                handleViewDetails(row.username, index)
                              }
                            >
                              View
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </Col>
          </Row>
        </div>

        <Row>
          <Col md="12">
            <PaginationComponent
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePagination}
            />
          </Col>
        </Row>
      </Container>
      {/* <ToastContainer /> */}
    </React.Fragment>
  );
};

export default KycReport;
